const KEY_PREFIX = "notificationSoundMuted:";

function storageKey(userId) {
	return `${KEY_PREFIX}${userId}`;
}

export function isNotificationSoundMuted(userId) {
	if (!userId) return false;
	try {
		return localStorage.getItem(storageKey(userId)) === "true";
	} catch {
		return false;
	}
}

export function setNotificationSoundMuted(userId, muted) {
	if (!userId) return;
	try {
		if (muted) {
			localStorage.setItem(storageKey(userId), "true");
		} else {
			localStorage.removeItem(storageKey(userId));
		}
	} catch {
		/* localStorage indisponível (modo privado) */
	}
}
